export const BILLING_TAB_KEYS = [
  "details",
  "payment-provider",
  "payouts",
  "payment-methods",
  "tax",
] as const

export type BillingTabKey = (typeof BILLING_TAB_KEYS)[number]
